module.exports = __webpack_public_path__ + "static/media/course.a26a87ef.PNG";